export const HOME = {
  emergentLink: 'emergent-link',
  landing: 'landing-page',
  brandLogo: 'brand-logo',
  tileHr: 'tile-hr',
  tileOperations: 'tile-operations',
  tileCompliance: 'tile-compliance',
  tileClientServices: 'tile-client-services',
  tileWealthAdvisors: 'tile-wealth-advisors',
  tileAlternativeSolutions: 'tile-alternative-solutions',
  themeToggle: 'theme-toggle-btn',
  adminLink: 'admin-link',
};
